<template>
    <rkm-modal
        :title="title"
        extra-large
        persistent
        ref="RkmModal"
    >
        <rkm-form
            v-if="model"
            ref="RkmForm"
        >
            <rkm-row v-if="!emitirSenha">
                <rkm-col cols="12">
                    <rkm-form-input-autocomplete
                        :repository="repositories.filaAtendimento.paciente"
                        :search-fields="fields"
                        :text-field="(value) =>  value.cns ? `${this.formatCns(value.cns)} - ${value.nome}` : value.nome"
                        :validations="validations.paciente"
                        label="Nome, data de nascimento (DD/MM/AAAA) ou prontuário"
                        uppercase
                        v-model="model.paciente"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :disabled="!!model.id"
                        :options="form.opcoesEntrada"
                        :validations="validations.opcaoEntrada"
                        label="Opção de entrada"
                        show-default-option
                        text-field="nome"
                        v-model="model.opcaoEntradaId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.prioridades"
                        :validations="validations.prioridade"
                        label="Prioridade"
                        show-default-option
                        text-field="nome"
                        v-model="model.prioridadeId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer="{cancel}">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, formats, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters({loading: 'getLoading'}),
        validations() {
            return {
                paciente: {required: true},
                opcaoEntrada: {required: true},
                prioridade: { required: !!this.model.opcaoEntradaId && this.form.opcoesEntrada.find(opcaoEntrada => opcaoEntrada.id === this.model.opcaoEntradaId).prioridadeObrigatoria},
            }
        },
    },
    created() {
        this.repositories = {
            filaAtendimento: this.getConectaSusRepository('farmacia.filaAtendimento'),
        }
    },
    data: () => ({
        emitirSenha: false,
        dispensar: false,
        fields: [
            {key: 'cadastro_cidadao.nome', searchable: true},
            {key: 'cadastro_cidadao.data_nascimento', searchable: true},
            {key: 'cadastro_paciente.prontuario', searchable: true},
        ],
        form: null,
        model: null,
        title: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(id = null, dispensar = false, emitirSenha = false) {
            if (!id) {
                this.title = 'Adicionar paciente na fila'
                if(emitirSenha) {
                    this.title = 'Emitir senha'
                }
            } else {
                if (dispensar) {
                    this.title = 'Atribuir paciente na fila'
                } else {
                    this.title = 'Editar paciente na fila'
                }
            }

            this.emitirSenha = emitirSenha
            this.dispensar = dispensar

            this.reset()

            if (id) {
                this.edit(id)
            } else {
                this.create()
            }

            this.$refs.RkmModal.show()
        },
        create() {
            this.setLoading()

            this.repositories.filaAtendimento.create()
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)

                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        edit(id) {
            this.setLoading()

            this.repositories.filaAtendimento.edit(id)
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        store() {
            this.setLoading()

            let request = {
                pacienteId: this.model.paciente ? this.model.paciente.id : null,
                opcaoEntradaId: this.model.opcaoEntradaId,
                prioridadeId: this.model.prioridadeId,
            }

            this.repositories.filaAtendimento.store(this.camelObjectKeysToSnakeRecursive(request))
                .then(() => this.$refs.RkmModal.hide())
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        update() {
            this.setLoading()

            const request = {
                pacienteId: this.model.paciente.id,
                prioridadeId: this.model.prioridadeId,
            }

            this.repositories.filaAtendimento.update(this.model.id, this.camelObjectKeysToSnakeRecursive(request))
                .then((response) => {
                    if (this.dispensar) {
                        this.$router.push({name: 'farmacia-dispensacao-create', params: {pacienteId: response.data.pacienteId, filaId: this.model.id}})
                    } else {
                        this.$refs.RkmModal.hide()
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.id) {
                        this.update()
                    } else {
                        this.store()
                    }
                })
        },
        reset() {
            this.form = null
            this.model = null
        },
    },
    mixins: [error, formats, repository, stringCase],
}
</script>